import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const OptionWrapper = styled.div`
    margin-top: 50px;
`;

export const Hr = styled.div`
    width: 100%;
    height: 0;
    border: 1px solid #e7e7f0;
    margin: 20px 0;
`;

export const LogoutFlex = styled.div`
    display: flex;
    position: absolute;
    bottom: 20px;
`;

export const LogoutIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const Logout = styled.div`
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1b73e8;
    margin-left: 5px;
    cursor: pointer;
`;
